/**
 * Welcher Befehl passt zur Eingabe.
 *
 * Bewusst einfach: Jedes eingegebene Wort muss irgendwo vorkommen (Beschriftung,
 * Gruppe, Hinweis). Kein unscharfer Abgleich mit Buchstabenabständen — der
 * findet zu viel und erklärt niemandem, warum ausgerechnet dieser Treffer oben
 * steht. Wer „impr" tippt, meint „Impressum", und das findet auch die
 * Teilzeichenkette.
 *
 * Die Reihenfolge ist die Antwort auf die Frage „wie nah dran": Was mit der
 * Eingabe ANFÄNGT, steht vor dem, was sie nur enthält.
 */
import type { Befehl } from '@/composables/useBefehle'

/** Wie viele Treffer höchstens. Mehr liest ohnehin niemand. */
export const HOECHSTENS = 50

function guete(b: Befehl, frage: string): number {
  const label = b.label.toLowerCase()
  if (label.startsWith(frage)) return 0
  if (label.split(/[\s/_-]+/).some((w) => w.startsWith(frage))) return 1
  if (label.includes(frage)) return 2
  return 3
}

export function suche(befehle: Befehl[], frage: string): Befehl[] {
  const worte = frage.toLowerCase().split(/\s+/).filter((w) => w !== '')
  if (worte.length === 0) return befehle.slice(0, HOECHSTENS)

  const erstes = worte[0] ?? ''
  const passend = befehle.filter((b) => {
    const heuhaufen = `${b.label} ${b.gruppe} ${b.hinweis ?? ''}`.toLowerCase()
    return worte.every((w) => heuhaufen.includes(w))
  })

  // Stabil sortieren: Bei gleicher Güte bleibt die Reihenfolge der Anmeldung,
  // und die ist die der Seite selbst.
  return passend
    .map((b, i) => ({ b, g: guete(b, erstes), i }))
    .sort((x, y) => (x.g - y.g) || (x.i - y.i))
    .slice(0, HOECHSTENS)
    .map((x) => x.b)
}
